import { render, staticRenderFns } from "./LifeAnnuity.vue?vue&type=template&id=285351ea&scoped=true&"
import script from "./LifeAnnuity.vue?vue&type=script&lang=js&"
export * from "./LifeAnnuity.vue?vue&type=script&lang=js&"
import style0 from "./LifeAnnuity.vue?vue&type=style&index=0&id=285351ea&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "285351ea",
  null
  
)

export default component.exports